var _mask, _rect, _rect2, _rect3, _mask2, _rect4, _rect5, _rect6, _mask3, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1044_15179",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.5,
    height: 7.92253,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.5,
    height: 7.92253,
    rx: 1,
    fill: "white",
    stroke: "#FF9D2E",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_1044_15179)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.375,
    y: 1.00391,
    width: 16.875,
    height: 1.50528,
    rx: 0.752641,
    fill: "#FF9D2E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.375,
    y: 5.01758,
    width: 7.5,
    height: 1.50528,
    rx: 0.752641,
    fill: "#FF9D2E"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_1044_15179",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 11.0391,
    width: 7.5,
    height: 7.92253,
    rx: 1
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 11.0391,
    width: 7.5,
    height: 7.92253,
    rx: 1,
    fill: "white",
    stroke: "#FF9D2E",
    strokeWidth: 3,
    mask: "url(#path-4-inside-2_1044_15179)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.375,
    y: 12.042,
    width: 20.625,
    height: 1.50528,
    rx: 0.752641,
    fill: "#FF9D2E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.375,
    y: 16.0566,
    width: 13.125,
    height: 1.50528,
    rx: 0.752641,
    fill: "#FF9D2E"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3_1044_15179",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 22.0771,
    width: 7.5,
    height: 7.92253,
    rx: 1
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 22.0771,
    width: 7.5,
    height: 7.92253,
    rx: 1,
    fill: "white",
    stroke: "#FF9D2E",
    strokeWidth: 3,
    mask: "url(#path-7-inside-3_1044_15179)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.375,
    y: 23.0811,
    width: 18.75,
    height: 1.50528,
    rx: 0.752641,
    fill: "#FF9D2E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.375,
    y: 27.0947,
    width: 15,
    height: 1.50528,
    rx: 0.752641,
    fill: "#FF9D2E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopics);
export default __webpack_public_path__ + "static/media/topics.3f7011c179ce5354d9e7c93108f9711b.svg";
export { ForwardRef as ReactComponent };